import React from "react";
import "react-toastify/dist/ReactToastify.css";
import footerButton from "../../../assets/images/footer_button.png";

export default function PromoBanner() {
  return (
    <section className="flex flex-col items-center gap-4 rounded-2xl border border-[#E2E2E2] bg-white p-5 shadow-lg md:flex-row md:justify-between md:px-8 md:py-6">
      <header>
        <h1 className="promo-text text-center font-manrope text-base sm:text-lg md:text-xl 2xl:text-2xl font-extrabold text-[#333333] md:text-left">
          Ready to Secure Your Online World?
        </h1>

        <p className="promo-text mt-1 text-center font-manrope text-xs sm:text-sm text-[#666A7C] md:text-left font-medium">
          Get the Geo VPN now and enjoy the internet without boundaries.
        </p>
      </header>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://play.google.com/store/apps/details?id=com.fast.secure.proxyvpn.unlimitedproxy.security&hl=en_US&gl=US"
        className="cursor-pointer shrink-0"
      >
        <img
          src={footerButton}
          alt="Get Geo VPN button"
          className="h-10 md:h-11 2xl:h-12 w-auto object-contain"
        />
      </a>
    </section>
  );
}
